"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import styles from "./styles.module.scss";
import FacultyCardWithDescription from "@molecules/FacultyCardWithDescription/FacultyCardWithDescription";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import ClickToScroll from "@/components/sections/NewLists/ClickToScroll";
import Markdown from "@/components/atoms/Markdown";

export default function FacultyWithDescription({ isDesktop, faculties }) {
  return (
    <>
      <div className={styles.mainContainer}>
        <div className={styles.root} id="landingPageFacultyList">
          <ClickToScroll id="landingPageFacultyList" />
          {faculties.map((d, index) => (
            <FacultyCardWithDescription key={index} {...d?.attributes} />
          ))}
        </div>
      </div>

      <div className={`${styles.containerCarousel} Carousel px-3`}>
        <Swiper
          autoplay={{
            delay: 6000,
          }}
          modules={[Pagination, Autoplay]}
          spaceBetween={16}
          slidesPerView={1}
          pagination={{ clickable: true }}
          className="Carousel__blueBullet Carousel__hAuto"
          breakpoints={{
            768: {
              slidesPerView: 2,
              spaceBetween: 15
            }
          }}
        >
          {faculties.map((d, index) => (
            <SwiperSlide key={index}>
              <FacultyCardWithDescription {...d?.attributes} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
}
